import React, { useEffect, useState } from "react";
import Preview from "./components/Preview";
import axiosInstance from "../../axiosInterceptor";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import Upload from "../../Components/upload";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { PopupSchema } from "../../Schema/Schema";

const AddPopups = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const [loading, setLoading] = useState(false);
  const [preview, setpreview] = useState(false);

  const initialValues = {
    heading: "",
    headingStyle: "",
    type: "",
    link: "",
    description: "",
    image: "",
    delay: 0,
    autoclose: "no",
    modalPosition: "",
  };

  const {
    errors,
    values,
    touched,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues,
    validationSchema: PopupSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const id = editData?.id;
        const response = id
          ? await axiosInstance.put(`popups/${id}`, values)
          : await axiosInstance.post(`popups`, values);
        setLoading(false);
        toast.success(response.data?.message);
        navigator("/popups");
      } catch (errors) {
        toast.error(errors.response?.data?.message);
        return errors.response?.data?.message;
      } finally {
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    if (editData?.id) {
      setFieldValue("heading", editData?.heading);
      setFieldValue("headingStyle", editData?.headingStyle);
      setFieldValue("type", editData?.type);
      setFieldValue("link", editData?.link);
      setFieldValue("description", editData?.description);
      setFieldValue("image", editData?.image);
      setFieldValue("delay", editData?.delay);
      setFieldValue("autoclose", editData?.autoclose);
      setFieldValue("modalPosition", editData?.modalPosition);
    }
  }, [editData]);

  return (
    <div className="content-wrapper">
      <div className="page-header mt-5 mx-4">
        <h3 className="page-title">{editData ? "Update" : "Add"} Popus</h3>
      </div>
      <div className="row grid-margin stretch-card rounded bg-white px-4 pt-4 pb-2 mb-3 shadow-sm">
        <div className="col-md-12">
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label className="col-form-label ">Popups Type</label>
                  <select
                    name="type"
                    className="form-control form-control-sm"
                    value={values.type}
                    onChange={handleChange}
                  >
                    <option value={""} disabled>
                      Select type
                    </option>
                    <option value={"newsletter"}>News Letter</option>
                    <option value={"default"}>Default</option>
                  </select>
                  {touched.type && errors.type && (
                    <small className="text-danger">{errors.type}</small>
                  )}
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label className="col-form-label ">Heading</label>
                  <input
                    className="form-control form-control-sm w-100 border border-dark  "
                    type="text"
                    id="heading"
                    name="heading"
                    placeholder="Enter Heading"
                    value={values.heading}
                    onChange={handleChange}
                  />
                  {touched.heading && errors.heading && (
                    <small className="text-danger">{errors.heading}</small>
                  )}
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label className="col-form-label ">Heading Style</label>
                  <select
                    className="form-control form-control-sm"
                    name="headingStyle"
                    value={values.headingStyle}
                    onChange={handleChange}
                  >
                    <option value={""} disabled>
                      Select style
                    </option>
                    <option value={"left"}>Left</option>
                    <option value={"center"}>Center</option>
                    <option value={"right"}>Right</option>
                  </select>
                  {touched.headingStyle && errors.headingStyle && (
                    <small className="text-danger">{errors.headingStyle}</small>
                  )}
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label className="col-form-label ">Link</label>
                  <input
                    className="form-control form-control-sm w-100 border border-dark  "
                    type="text"
                    id="link"
                    name="link"
                    placeholder="Enter Link"
                    value={values.link}
                    onChange={handleChange}
                  />
                  {touched.link && errors.link && (
                    <small className="text-danger">{errors.link}</small>
                  )}
                </div>
              </div>

              <div className="col-md-6" style={{ marginTop: "7px" }}>
                <label className="form-label fw-bold"> Upload Image</label>
                <Upload
                  initialImage={values.image}
                  apiUrl={"uploads?label=popups"}
                  onChange={(path) => setFieldValue("image", path)}
                />
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label className="col-form-label ">Description</label>
                  <input
                    className="form-control form-control-sm w-100 border border-dark  "
                    type="text"
                    id="description"
                    name="description"
                    placeholder="Enter Description"
                    value={values.description}
                    onChange={handleChange}
                  />
                  {touched.description && errors.description && (
                    <small className="text-danger">{errors.description}</small>
                  )}
                </div>
              </div>

              <div className="col-md-4">
                <div className="form-group">
                  <label className="col-form-label ">Modal Position</label>
                  <select
                    className="form-control form-control-sm"
                    name="modalPosition"
                    id="modalPosition"
                    value={values.modalPosition}
                    onChange={handleChange}
                  >
                    <option value={""} disabled>
                      Select Position
                    </option>
                    <option value={"top-left"}>Top Left</option>
                    <option value={"top-right"}>Top Right</option>
                    <option value={"center"}>Center</option>
                    <option value={"bottom-left"}>Bottom Left</option>
                    <option value={"bottom-right"}>Bottom Right</option>
                  </select>
                </div>
              </div>

              <div className="col-md-4 " style={{ marginTop: "20px" }}>
                <div className="form-group">
                  <label htmlFor="delay">Popup Delay: {values.delay} second(s)</label>
                  <div>
                    <input
                      type="range"
                      id="delay"
                      min="0"
                      max="30"
                      step="1"
                      className="form-range "
                      value={values.delay}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="form-group mb-4">
                  <label htmlFor="exampleInputUsername2" className="col-form-label">
                    Autoclose Popups
                  </label>
                  <div className="d-flex">
                    <div className="form-check form-check-inline d-flex">
                      <input
                        className="form-check-input border border-dark  "
                        type="radio"
                        name="autoclose"
                        id="yes"
                        value="yes"
                        checked={values.autoclose === "yes"}
                        onChange={handleChange}
                      />
                      <label className="form-check-label ml-0" htmlFor="yes">
                        Yes
                      </label>
                    </div>

                    <div className="form-check form-check-inline d-flex mx-4">
                      <input
                        className="form-check-input border border-dark  "
                        type="radio"
                        name="autoclose"
                        id="no"
                        value="no"
                        checked={values.autoclose === "no"}
                        onChange={handleChange}
                      />
                      <label className="form-check-label ml-0" htmlFor="no">
                        No
                      </label>
                    </div>
                  </div>
                </div>
              </div>


              <div
                className="text-start mt-4"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      {editData ? "Updating..." : "Submitting..."}
                    </>
                  ) : editData ? (
                    "Update"
                  ) : (
                    "Add"
                  )}
                </button>

                <Link to="/popups">
                  <button className="btn btn-danger mx-2">Cancel </button>
                </Link>

                <button
                  type="button"
                  onClick={() => setpreview((preview) => !preview)}
                  className="btn btn-dark mx-2"
                >
                  Preview{" "}
                </button>
              </div>
            </div>
          </form>
        </div>

        {preview && (
          <Preview
            form={values}
            isOpen={preview}
            onClose={() => setpreview(false)}
            position={values.modalPosition}
          />
        )}
      </div>
    </div>
  );
};

export default AddPopups;
